<template>
  <Modal :value="value" @hide="hide()" title="Move package">
    <template slot="body" class="content">
      <div
        v-if="item.source.permission && item.source.permission < 16"
        class="notification is-danger"
      >
        This action requires <i>Delete</i> permission that you currently lack.
      </div>

      <p>
        Move <i>{{ item.chocoPackage.Title }}</i> from
        <i>{{ item.source.name }}</i> to the selected repository.
      </p>

      <p>
        This is a feature mainly for package testing, to be able to separate
        test repositories from production repositories.
      </p>

      <div class="notification is-warning">
        This can cause temporary synchronization conflicts for computers that is
        online and have this package installed/uninstalled. You can resolve this
        by restarting the DeploymentClient service.
      </div>

      <div class="select">
        <select v-model="selectedSource">
          <option disabled :value="null">Select new repo</option>
          <option
            v-for="source of sources.filter(
              (x) => !x.external && x.uid !== item.source.uid
            )"
            :key="source.uid"
            :value="source"
            >{{ source.name }}</option
          >
        </select>
      </div>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <div
          @click="move(selectedSource)"
          :disabled="!selectedSource"
          class="button is-success"
        >
          Move
        </div>
        <div class="button" @click="hide()">Cancel</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
import { post, postApi } from "@/utils/http";

export default {
  props: {
    value: Boolean,
    item: Object,
    sources: Array,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
  },
  data() {
    return {
      repoName: "",
      valid: false,
      isLoading: false,
      selectedSource: null,
    };
  },
  created() {},
  methods: {
    async move() {
      this.isLoading = true;
      try {
        await post(`${this.item.source.url}package/move`, {
          Id: this.item.chocoPackage.Id,
          Version: this.item.chocoPackage.Version,
          source: this.selectedSource,
        });

        try {
          await postApi("delete/sourcePackage", {
            packageHash: this.item.chocoPackage.PackageHash,
            packageName: this.item.chocoPackage.Id,
            sourceUID: this.item.source.uid,
          });

          this.$emit("change", this.item);
          this.isLoading = false;
          this.hide();
        } catch (err) {
          console.log(err);
          if (err.response.status === 401)
            this.$helpers.notify("Permission denied", "", "danger");
          else this.$helpers.notify("Error", "Internal error", "danger");
        }
      } catch (err) {
        console.log(err);
        if (err.response.status === 401)
          this.$helpers.notify("Permission denied", "", "danger");
        else this.$helpers.notify("Error", "Internal error", "danger");
      }

      this.isLoading = false;
    },

    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
  },
};
</script>
